<app-modal [dismissible]="true"
           [autoZIndex]="true"
           [baseZIndex]="10000">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.strain.registry.details.mainPartNumberModal.title' | translate }}</h5>
    </ng-container>
    <ng-container modal-body>
        <div class="current-part-number">
            <span class="label">{{ 'admin.strain.registry.details.mainPartNumberModal.current' | translate }}</span>
            <span class="value">{{ getDisplayName() }}</span>
        </div>

        <app-dropdown-autocomplete
            [label]="'admin.strain.registry.details.mainPartNumberModal.select' | translate"
            [items]="equivalentPartNumbers"
            displayField="nameWithSAP"
            valueField="id"
            appendTo="body"
            [formControl]="selectedPartNumber"
            [showErrors]="(showValidations || selectedPartNumber.touched) && selectedPartNumber.invalid"
            [canAddOther]="false">
        </app-dropdown-autocomplete>
    </ng-container>
    <div class="modal-footer" modal-footer>
        <app-button type="simple" (click)="close()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button type="primary"
                    [disabled]="isUpdateInProgress"
                    (click)="onSave()">
            {{ 'generic.buttons.save' | translate }}
        </app-button>
    </div>
</app-modal>
